const DESIGN_RETURN_ORDER_KEY = 'order:returnFromDesign';

export function stashDesignReturnOrderId(orderId) {
  if (orderId == null || orderId === '') return;
  try {
    sessionStorage.setItem(DESIGN_RETURN_ORDER_KEY, String(orderId));
  } catch {
    // ignore
  }
}

export function takeDesignReturnOrderId() {
  try {
    const value = sessionStorage.getItem(DESIGN_RETURN_ORDER_KEY);
    sessionStorage.removeItem(DESIGN_RETURN_ORDER_KEY);
    return value || null;
  } catch {
    return null;
  }
}
